import { api } from '../../../api/client';

export const regexApi = {
  /** Lists all regex rules in the system. */
  getAll: () =>
    api.get('/build/regex'),

  /**
  * Creates a regex rule.
   * @param {object} data
   */
  create: (data) =>
    api.post('/build/regex', data),

  /**
  * Updates a regex rule by ID.
   * @param {string|number} id
   * @param {object} data
   */
  update: (id, data) =>
    api.put(`/build/regex/${id}`, data),

  /**
  * Deletes a regex rule by ID.
   * @param {string|number} id
   */
  remove: (id) =>
    api.delete(`/build/regex/${id}`),

  //select
  getNames:()=>api.get('/build/regex/getNames')
};
